import React                                                        from 'react';
import { withStyles }                                               from '@material-ui/core/styles';
import {colores, globales,funciones}                                from '../../global';
import AuthService                                                  from '../../AuthService';
import Request                                                      from 'superagent';
import CustomTable                                                  from '../../components/CustomTable';
import {Table}                                                      from '@devexpress/dx-react-grid-material-ui';
import TableRowsIndexer                                             from '../../components/tableRowsIndexer'
import Dialog                                                       from '@material-ui/core/Dialog';
import DialogContent                                                from '@material-ui/core/DialogContent';
import DialogTitle                                                  from '@material-ui/core/DialogTitle';
import CircularProgress                                             from '@material-ui/core/CircularProgress';
import Backdrop                                                     from '@material-ui/core/Backdrop';
//import Tooltip                                                      from '@material-ui/core/Tooltip'
import {Tab, Checkbox, Typography }                                 from '@material-ui/core';
import { TabContext, TabList, TabPanel }                            from '@material-ui/lab';
import BarraBotones                                                 from '../../components/Barra_menu';

let Auth = new AuthService();
var ip=globales.ip
var border_dialog=globales.border_dialog
//var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
var movil_pequeño=/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

let isVisibleRowSelected = false;
//const colorRowSelected =  'rgb('+ colores.tabla.selection +')';
//let alternateColorRow1 = colores.tabla.alternateColorRow1; 
//let alternateColorRow2 = colores.tabla.alternateColorRow2;


const VirtualTable_cellComponent_favor = (props) => {
    const { column }    = props;
    const {row}         = props;

    if(column.name==='MONTO_TOTAL'){
        return(
            <Table.Cell {...props}>
                {row.SIMBOLO+' '+row.MONTO_TOTAL}
            </Table.Cell>
        );
    }

    return(
        <Table.Cell {...props}/>
      );
}

const getRowId = row => row.ID_FACTURA;
const getRowId_favor = row => row.ID_FACTURA;



/*                           CLASES DE ESTILO                       */

var styles = theme =>({
    Dialog:{
        borderRadius: border_dialog,
        margin:0,
        padding:0
    },
    backdrop: {
      zIndex: 500000,
      color: '#fff', 
      flexDirection: 'column'
    },
    select: { //CONFIGURA EL SELECT 
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'50%',
      },
      textField: {
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'20%',
        width: '20%'      
      },
      root:{
        paddig:0,
        margin:0,
        background: 'white',
        borderRadius:3,
        color: 'inherit',
        minHeight: '30px',
        maxHeight: '30px',
      },
      selected:{
          background:colores.tabla.encabezado,
          color: '#ffff'
      },

    })

    const columns= [{name:'CHECKED',title: ' '},{name:'ID_FACTURA',title: 'Factura'},
    {name:'DESCRIPCION',title: 'Descripción'},
    {name:'FECHA_PROCESO',title: 'Fecha'},
    {name:'FECHA_PROCESO_ANT',title: 'FECHA_PROCESO_ANT'},
    {name:'MONTO_TOTAL',title: 'Monto'},
    {name:'SIMBOLO',title: 'SIMBOLO'},
    ];

    const columns_favor= [{name:'ID_FACTURA',title: 'Factura'},
    {name:'DESCRIPCION',title: 'Descripción'},
    {name:'FECHA_PROCESO',title: 'Fecha'},
    {name:'MONTO_TOTAL',title: 'Monto'},
    {name:'SIMBOLO',title: 'SIMBOLO'},
    ];

    const defaultHiddenColumnNames= ['FECHA_PROCESO_ANT','SIMBOLO'];
    const defaultHiddenColumnNames_favor= ['ID_FACTURA','SIMBOLO'];

    const tableColumnExtensions= [
        { columnName: 'CHECKED', wordWrapEnabled: false, align: 'center',width: 50},
        { columnName: 'ID_FACTURA', wordWrapEnabled: false, align: 'center',width: 100},
        { columnName: 'DESCRIPCION', wordWrapEnabled: true, align: 'left',width: movil_pequeño?250:400},
        { columnName: 'FECHA_PROCESO', wordWrapEnabled: false, align: 'left',width: movil_pequeño?80:150},
        { columnName: 'MONTO_TOTAL', wordWrapEnabled: false, align: 'center',width: 150},
    ];

    const tableColumnExtensions_favor= [
        { columnName: 'DESCRIPCION', wordWrapEnabled: true, align: 'left',width:movil_pequeño?250:500},
        { columnName: 'FECHA_PROCESO', wordWrapEnabled: false, align: 'left',width: movil_pequeño?80:150},
        { columnName: 'MONTO_TOTAL', wordWrapEnabled: false, align: 'center',width: 150},
    ];


/*                                        EXPORT                                      */
export default withStyles(styles)(
    class Estado_Cuenta_Alumno extends React.Component {
      tablaRef = React.createRef();

      constructor(props) {
        super(props);
        this.l= props.l
        this.e= props.e
        this.i= props.i
        this.isVisibleRowSelected=isVisibleRowSelected
        this.actualizarbarra=props.actualizarbarra
        this.actualizarcircular=props.actualizarcircular

        this.state = {
            openBackDrop:      false, 
            open_mover:        false,
            isLoggin:          undefined,
            heightTableMain:    0,
            rows_facturas: [],
            rows_favor: [],
            selection: null,
            grouping: [],
            expandedGroups: [],
            filteringColumnExtensions: [],
            filters: [],
            expandedRowIds: [],
            enabledFilterRows: true,
            value: "1",
        }

        const VirtualTable_cellComponent = (props) => {
          const { column }    = props;
          const {row}         = props;
      
          if(column.name==='CHECKED'){
            return(
                <Table.Cell {...props}>
                    <Checkbox checked={row.CHECKED} onChange={this.handleChangeCheckbox(row.ID_FACTURA)}/>
                </Table.Cell>
            );
          }
      
          if(column.name==='MONTO_TOTAL'){
              return(
                  <Table.Cell {...props}>
                      {row.SIMBOLO+' '+row.MONTO_TOTAL}
                  </Table.Cell>
              );
          }
      
          return(
              <Table.Cell {...props}/>
            );
      }

      this.VirtualTable_cellComponent=VirtualTable_cellComponent
        
    }; //FIN CONSTRUCTORS
    handleChangeCheckbox= (ID_FACTURA)=>event => {
      this.setState({ open_mover: true,selection:  ID_FACTURA});
    }

    Mover= ()=>{
      this.setState({ openBackDrop: true }, ()=>{
        try{
        new Request
        .post(`${ip}/EstadoCuentaAlumno/Mover_factura`)
        .set({'authorization': 'Bearer ' + Auth.getToken() })
        .set('Content-Type', 'application/json')
        .send({ ID_FACTURA:  this.state.selection, cuenta_alumno: Auth.getProfile().user})
        .retry(0)
        .timeout({ response: 15000, deadline: 60000, }) 
        .end((err, res) => {
          if (err) { 
            if (err.toString().substr(0,16) === 'Error: Forbidden')
            { 
              window.location.reload();
              return;  
            }       
            this.setState({ openBackDrop: false }, ()=> { 
              funciones.showToast('e', 'Error de conexión'); 
            });
          }
    
          const rows = JSON.parse(res.text);
          if (rows.length > 0) 
          {    
              if (rows[0].RESP === undefined)
             {   
              var filas_facturas=[]
              var filas_favor=[]

              rows.forEach(element => {
                  if(element.TIPO==='FACTURA')
                  {
                      filas_facturas.push(element)
                  }
                  else if(element.TIPO==='FAVOR')
                  {
                      filas_favor.push(element)
                  }
              });

                  this.setState({open_mover: false,selection: null, openBackDrop: false, rows_facturas: filas_facturas,rows_favor: filas_favor, heightTableMain: funciones.getHeightTableMain(movil_pequeño,this).heightTable}); 
              }
              else{
                    this.setState({open_mover: false,selection: null, openBackDrop: false}, ()=>{funciones.showToast('w', rows[0].RESP);});
              }
          }           
          });       
        }
        catch(ex){
          this.setState({ openBackDrop: false}, ()=>{
          funciones.showToast('e', 'Error de conexión');
          });
        }
      })
    }

componentDidMount()
{
        let _this = this;
        _this.actualizarbarra(false)

        Auth.loggedIn().then( function(b){
            _this.setState({ isLoggin: b})
            if(b)
            Request.get(`${ip}/EstadoCuentaAlumno/obtener_facturas_estado_cuenta/${Auth.getProfile().user}`)
            .set({'authorization': 'Bearer ' + Auth.getToken() })
            .retry(1)
            .timeout({ response: 20000, deadline: 50000, }) 
            .end((err, res)=> {
             if (err) { 
                    if (err.toString().substr(0,16) === 'Error: Forbidden')
                    {
                      window.location.reload();
                      return;  
                    }
                    (async function() {
                        funciones.showToast('e','Error de conexión')
                    })();//FIN FUNCION ASYNC
                    return;
            }
            const tmp = JSON.parse(res.text);
            if(tmp.length>0){
                var filas_facturas=[]
                var filas_favor=[]

                tmp.forEach(element => {
                    if(element.TIPO==='FACTURA')
                    {
                        filas_facturas.push(element)
                    }
                    else if(element.TIPO==='FAVOR')
                    {
                        filas_favor.push(element)
                    }
                });

                    _this.setState({rows_facturas: filas_facturas,rows_favor: filas_favor, heightTableMain: funciones.getHeightTableMain(movil_pequeño,_this).heightTable
                    }); 
                }
                else
                {
                    _this.setState({rows_facturas: [],rows_favor: [], heightTableMain:   funciones.getHeightTableMain(movil_pequeño,_this).heightTable})
                }
       
            _this.actualizarbarra(true)
          })
        })
}

handleChange=(event, newValue)=> {
    this.setState({value: newValue});
}

cerrarmodal=()=>event=>{
  this.setState({open_mover: false,selection: null});
}

/*                                          RENDER                          */
render() {
    const { classes } = this.props;

    const botones = [
      {icono: 'CheckCircle',  nombre: 'Aceptar',escritura:true,onclick: this.Mover
      , display:'auto'},
      {icono: 'Close',  nombre: 'Cerrar' ,onclick: this.cerrarmodal(), display:'auto', color: 'red'},
    ]


    if (this.state.isLoggin === true )
    {
    return (    
    <React.Fragment>
      <Backdrop className={classes.backdrop}  open={this.state.openBackDrop}>
          <CircularProgress color="inherit" />
          <span style={{ marginTop: '10px' }}>{this.state.open_seleccion?'Guardando...':this.state.open_borrar?'Eliminando...':''}</span>
      </Backdrop>
      {/*--------------------------------------------------------DIALOG PARA ELIMINAR---------------------------------------------------------------------*/}

      <Dialog
        open={this.state.open_mover}
        //onClose={this.cerrarmodal()}
        disableEnforceFocus   disableAutoFocus
        maxWidth='xs'
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth= {true} classes = {{ paper: classes.Dialog}}
        style={{zIndex: 200000,}} fullScreen={movil_pequeño?true:false}
      >
      <DialogTitle>
      <Typography component='span'  variant='subtitle2'>
      {'Mover Cuota'}
      </Typography>
      </DialogTitle>
      <DialogContent>
      <Typography align='center'>
          ¿Está seguro de mover la cuota?
      </Typography>
      </DialogContent>
          <BarraBotones botones={botones} l={this.l} e={this.e} i={this.i}/>
      </Dialog>
    <TabContext value={this.state.value}>
    <TabList centered={false} orientation='horizontal'  onChange={this.handleChange} style={{maxHeight:'35px',minHeight: '35px',height: '35px',background: 'inherit',color:'inherit',borderBottom: '1px solid rgba(0,0,0,0.1)'}}  >
        <Tab style={{textTransform: 'none'}}  classes={{root: classes.root, selected: classes.selected}} 
        label="Saldo a Pagar" value={"1"} />
        <Tab style={{textTransform: 'none'}} classes={{root: classes.root,selected: classes.selected}} 
        label="Saldo a Favor" value={"2"}  />
    </TabList>

    <TabPanel value = {"1"} >
      <div ref={this.tablaRef} style={{marginTop:5,background:'white',marginLeft:movil_pequeño?globales.tabla.marginleft_movil:globales.tabla.marginleft,marginRight:movil_pequeño?globales.tabla.marginright_movil:globales.tabla.marginright}}>
      <CustomTable
            Columns={columns}                                    
            Rows={this.state.rows_facturas}                                          
            TableColumnExtensions={tableColumnExtensions}
            DefaultHiddenColumnNames={defaultHiddenColumnNames}
            getRowId = {getRowId}
            height={this.state.heightTableMain-20}
            //ExpandedRowDetailIds = {this.state.expandedRowIds}
            //onExpandedRowDetailIdsChange={this.onExpandedRowDetailIdsChange}
            enabledFilterRows= {false}
            //RowDetail={this.RowDetail}
            standarPlugin = { <TableRowsIndexer/> }
            VirtualTable_cellComponent={this.VirtualTable_cellComponent}
            showSelectionColumn={false}
        />
      </div>
    </TabPanel>
    <TabPanel value = {"2"} >
    <div style={{marginTop:5,background:'white',marginLeft:movil_pequeño?globales.tabla.marginleft_movil:globales.tabla.marginleft,marginRight:movil_pequeño?globales.tabla.marginright_movil:globales.tabla.marginright}}>
      <CustomTable
            Columns={columns_favor}                                    
            Rows={this.state.rows_favor}                                          
            TableColumnExtensions={tableColumnExtensions_favor}
            DefaultHiddenColumnNames={defaultHiddenColumnNames_favor}
            getRowId = {getRowId_favor}
            height={this.state.heightTableMain-20}
            //ExpandedRowDetailIds = {this.state.expandedRowIds}
            //onExpandedRowDetailIdsChange={this.onExpandedRowDetailIdsChange}
            enabledFilterRows= {false}
            //RowDetail={this.RowDetail}
            standarPlugin = { <TableRowsIndexer/> }
            VirtualTable_cellComponent={VirtualTable_cellComponent_favor}
            showSelectionColumn={false}
        />
      </div>
    </TabPanel>
    </TabContext>
    </React.Fragment>
    ); /// finaliza return
    }
    else if (this.state.isLoggin === false)
    {
        Auth.logout()
        window.location.reload();
        return; 
    }


    return null;
} /// finaliza render
} /// finaliza class
)/// finaliza withStyles

    

    